<template>
  <!-- Vue 3 フラグメント: v-app-bar / v-navigation-drawer / v-main を兄弟要素として並べる -->
  <!-- Vuetify 3 のレイアウトシステム（provide/inject）が正しく機能する -->
  <template v-if="hidden === false">
    <Header />
    <navigation-drawer :links="links" />
  </template>
  <v-main>
    <router-view @updateNavigation="updateNavigation" />
  </v-main>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/organisms/agency/Header';
import NavigationDrawer from '@/components/organisms/agency/NavigationDrawer';
import { nonHeaderPathName, navigationLinks } from '@/lib/const';

export default {
  name: 'Main',
  components: {
    Header,
    NavigationDrawer,
  },
  data() {
    return {
      hidden: true,
      auth: false,
      links: navigationLinks,
    };
  },
  created() {
    // 初回ロード時（Google ログインのリダイレクト後など）も hidden を正しく設定する
    // $route watch はルート変化時のみ発火するため、初回マウント時は created で初期化が必要
    // Vue Router 4 の初回ナビゲーション完了前は $route.name が null になる場合があるため
    // null の場合は data() の初期値 hidden:true を維持する（ヘッダーを安全に非表示に保つ）
    if (this.$route.name) {
      this.hidden = nonHeaderPathName.agency.indexOf(this.$route.name) >= 0;
      this.updateNavigation();
    }
  },
  watch: {
    async $route(val) {
      this.hidden = nonHeaderPathName.agency.indexOf(val.name) >= 0;
      this.updateNavigation();
    },
  },
  methods: {
    ...mapGetters('user', ['userDetail']),

    updateNavigation() {
      const links = JSON.parse(JSON.stringify(navigationLinks));
      const selectedLinks = this.selectLinks(links).map(link => ({
        ...link,
        title: this.$t(link.title),
      }));
      this.links = selectedLinks;
    },

    selectLinks(links) {
      return links
        .filter(link => {
          return link.role && this.userDetail()
            ? link.role.includes(this.userDetail().role)
            : null;
        })
        .filter(link => {
          if (link.items) {
            link.items = this.selectLinks(link.items);
            if (link.items.length === 0) return false;
          }
          return true;
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/index.scss';
</style>
